import React from 'react';

export default function StatusBadge({ status }) {
  const colors = {
    parsed: { bg: '#D1FAE5', color: '#2D8F5E' },
    pending: { bg: '#FEF3C7', color: '#D97706' },
    error: { bg: '#FEE2E2', color: '#DC2626' },
  };
  const c = colors[status] || colors.pending;
  return (
    <span style={{ borderRadius: 9999, padding: '2px 10px', fontSize: 12, fontWeight: 500, background: c.bg, color: c.color }}>
      {status}
    </span>
  );
}
